import { createAction } from '@reduxjs/toolkit';

import { UserAddressFormValuesType } from '../componenes/EditUserAddressComponent/constants/userAddressFormFields';
import { EditContactsPayloadData } from '@modules/App/interfaces/EditUserContactPayloadData';

export const getUserProfileData = createAction<string>('userProfilePage/getUserProfileData');
export const editUserContacts = createAction<EditContactsPayloadData>('userProfilePage/editUserContacts');
export const updateUserAddressData = createAction<UserAddressFormValuesType>('userProfilePage/updateUserAddressData');
export const loadMetroAreas = createAction('userProfilePage/loadMetroAreas');
